export default __webpack_public_path__ + "static/media/privacy.280b6dd0.png";